var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9479 6.08814C14.8855 5.89215 14.7654 5.71952 14.6034 5.59279C14.4414 5.46605 14.245 5.39109 14.0397 5.37769L10.3278 5.11792L8.95086 1.65064C8.87634 1.45895 8.74566 1.29424 8.57593 1.1781C8.4062 1.06195 8.20535 0.999791 7.99969 0.999756H7.99871C7.79337 1.00012 7.59291 1.06244 7.42356 1.17857C7.2542 1.29469 7.12383 1.45922 7.04949 1.65064L5.65203 5.13794L1.96062 5.37769C1.75537 5.39109 1.55892 5.46605 1.39691 5.59279C1.2349 5.71952 1.11485 5.89215 1.05242 6.08814C0.986563 6.28691 0.982083 6.5009 1.03956 6.70226C1.09704 6.90361 1.21382 7.08299 1.37469 7.21704L4.21453 9.61743L3.3698 12.9402C3.31158 13.164 3.32229 13.4002 3.40052 13.6178C3.47876 13.8355 3.62088 14.0244 3.80828 14.1599C3.98921 14.2915 4.20557 14.3657 4.42921 14.3726C4.65285 14.3796 4.87341 14.3191 5.06218 14.199L7.99187 12.343C7.99578 12.3401 7.99968 12.3381 8.00847 12.343L11.1608 14.3401C11.332 14.4494 11.5321 14.5046 11.7351 14.4983C11.9381 14.492 12.1345 14.4246 12.2985 14.3049C12.4683 14.1822 12.5971 14.011 12.668 13.8139C12.7389 13.6167 12.7487 13.4027 12.696 13.2L11.7985 9.57007L14.6257 7.21704C14.7865 7.08299 14.9033 6.90361 14.9608 6.70226C15.0183 6.5009 15.0138 6.28691 14.9479 6.08814Z",
    fill: "#075FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBlueStar);
export default __webpack_public_path__ + "static/media/ico-blue-star.8d7be641.svg";
export { ForwardRef as ReactComponent };